import type { Observable } from 'rxjs';
import type { CrmPipeline } from '@integrations/crm-pipelines/contracts/crm-pipeline.contract';

import { Injectable, InjectionToken, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { parseResponse } from '@integrations/shared/parse-response';
import { CrmPipelineCollectionResponseSchema } from '@integrations/crm-pipelines/contracts/crm-pipeline.contract';

export const CRM_SERVICE_API_BASE = new InjectionToken<string>('CRM_SERVICE_API_BASE', {
    providedIn: 'root',
    factory: () => '/api/landings-service/crm',
});

@Injectable({ providedIn: 'root' })
export class CrmPipelinesApiService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = inject(CRM_SERVICE_API_BASE);

    public getPipelinesList(): Observable<CrmPipeline[]> {
        return this.http.get<unknown>(`${this.baseUrl}/pipelines`).pipe(
            map(
                (res) =>
                    parseResponse(res, CrmPipelineCollectionResponseSchema, {
                        endpoint: 'crm/pipelines',
                        method: 'GET',
                    }).data
            )
        );
    }
}
